export const positiveIntegerOrValue = (
  value: number | undefined,
  defaultValue: number
): number =>
  value === undefined
    ? Math.round(defaultValue)
    : value < 1
    ? 1
    : Math.round(value);
